import JourneyTelemetryExtended from '@/models/JourneyTelemetryExtended'
import { CollectionTransformer } from '@/transformers/index'
import { ExtendedRouteTransformer } from '@/transformers/ExtendedRouteTransformer'
import Telemetry from '@/models/Telemetry'

export default class JourneyTelemetryExtendedV2Transformer {
    // TODO: dokończyc

    constructor (
        collectionTransformer = new CollectionTransformer(),
        extendedRouteTransformer = new ExtendedRouteTransformer()
    ) {
        this.collectionTransformer = collectionTransformer
        this.extendedRouteTransformer = extendedRouteTransformer
    }

    transform (data) {
        return new Telemetry(
            data.route,
            data.startPoint,
            data.endPoint,
            data.routeBoundary,
            data.startUtc,
            data.endUtc,
            data.idlePoints,
            data.noGpsEvents,
            data.journeyStartGapPoints,
            data.journeyEndGapPoints,
            data.journeySpeedPoints,
            data.lengthMeters,
            data.lengthKm,
            data.id
        )
    }
}
